import React from 'react';
import PropTypes from 'prop-types';
import { Button, Download02Icon } from '@metarouter-private/mr-mui';

export default function ExportAllButton({ onClick, disabled }) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      startIcon={<Download02Icon />}
      variant="soft"
      size="large"
      data-test-id="bulk-export-button"
    >
      Export All
    </Button>
  );
}

ExportAllButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
